export default {
  title: 'Menus de QR Code',
  newMenu: 'Novo menu',
  name: 'Nome',
  createdAt: 'Criado em',
  enabled: 'Ativado',
  actions: 'Ações',
  editLinks: 'Editar links',
  editSettings: 'Editar configurações'
}
